import { render, staticRenderFns } from "./profit-and-loss-v2.vue?vue&type=template&id=8dc77c12&"
import script from "./profit-and-loss-v2.vue?vue&type=script&lang=js&"
export * from "./profit-and-loss-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports